import React from "react";
import { useLocation, Link } from "react-router-dom";

const PaymentSuccess = () => {
  const location = useLocation();
  const { amount, receiptUrl } = location.state || {};

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-6">
        <div className="text-center">
          <svg
            className="mx-auto h-12 w-12 text-green-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <h2 className="mt-4 text-2xl font-bold text-gray-800">Payment Successful!</h2>
          <p className="mt-2 text-gray-600">
            Thank you for your purchase. Amount paid: ${amount?.toFixed(2)}
          </p>
          {receiptUrl && (
            <a href={receiptUrl} target="_blank" rel="noopener noreferrer" className="mt-4 inline-block text-blue-500 hover:text-blue-700">
              View Receipt
            </a>
          )}
          <div className="mt-6">
            <Link
              to="/"
              className="inline-block bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
            >
              Return to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
